import { Link2 } from "lucide-react";
import { Type } from "@themes/pollinator/ui/Type";
import { SectionHeading } from "@themes/pollinator/ui/SectionHeading";
import { ClipboardCopyButton } from "@themes/pollinator/ui/ClipboardCopyButton";

export type Props = {
  shortcode: string;
  /** Custom title (default: "Share Your Link") */
  title?: string;
  /** Custom description (default: "Share this link directly for people to join.") */
  description?: string;
  /** Optional name label to display above the URL (e.g., program name) */
  name?: string;
  /** Whether to show the section heading wrapper (default: true) */
  showHeading?: boolean;
};

/**
 * Section displaying the direct invitation URL with copy button.
 */
export function InvitationLinkSection({
  shortcode,
  title = "Share Your Link",
  description = "Instead of sending email invitations, you can use this link to invite friends directly. (Please share with care.)",
  name,
  showHeading = true,
}: Props) {
  const invitationUrl = `${window.location.origin}/invitation/${shortcode}`;

  const content = (
    <div className="flex flex-col gap-2">
      {name && (
        <Type as="span" variant="h6" className="text-brand-800">
          {name}
        </Type>
      )}
      <div className="flex flex-row gap-2 items-center">
        <div className="flex items-center gap-2 border bg-brand-50 rounded-sm py-2 px-4 flex-grow overflow-hidden">
          <Link2 className="w-4 h-4 text-brand-600 flex-shrink-0" />
          <Type as="span" variant="caption" className="text-brand-700 truncate">
            {invitationUrl}
          </Type>
        </div>
        <ClipboardCopyButton textToCopy={invitationUrl} label="Copy Link" />
      </div>
    </div>
  );

  if (!showHeading) {
    return content;
  }

  return (
    <SectionHeading title={title} description={description} className="gap-6">
      {content}
    </SectionHeading>
  );
}

export default InvitationLinkSection;
